var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / plus-curved"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0371 7.46265C12.5894 7.46265 13.0371 7.91036 13.0371 8.46265V15.6111C13.0371 16.1634 12.5894 16.6111 12.0371 16.6111C11.4848 16.6111 11.0371 16.1634 11.0371 15.6111V8.46265C11.0371 7.91036 11.4848 7.46265 12.0371 7.46265Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45898 12.0369C7.45898 11.4846 7.9067 11.0369 8.45898 11.0369H15.6148C16.1671 11.0369 16.6148 11.4846 16.6148 12.0369C16.6148 12.5891 16.1671 13.0369 15.6148 13.0369H8.45898C7.9067 13.0369 7.45898 12.5891 7.45898 12.0369Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13704 5.13729C3.91213 6.3622 3.2998 8.4413 3.2998 12.0369C3.2998 15.6325 3.91213 17.7116 5.13704 18.9365C6.36195 20.1614 8.44106 20.7737 12.0366 20.7737C15.6322 20.7737 17.7113 20.1614 18.9363 18.9365C20.1612 17.7116 20.7735 15.6325 20.7735 12.0369C20.7735 8.4413 20.1612 6.3622 18.9363 5.13729C17.7113 3.91238 15.6322 3.30005 12.0366 3.30005C8.44106 3.30005 6.36195 3.91238 5.13704 5.13729ZM3.72283 3.72307C5.54081 1.90509 8.33013 1.30005 12.0366 1.30005C15.7432 1.30005 18.5325 1.90509 20.3505 3.72307C22.1684 5.54106 22.7735 8.33037 22.7735 12.0369C22.7735 15.7434 22.1684 18.5327 20.3505 20.3507C18.5325 22.1687 15.7432 22.7737 12.0366 22.7737C8.33013 22.7737 5.54081 22.1687 3.72283 20.3507C1.90485 18.5327 1.2998 15.7434 1.2998 12.0369C1.2998 8.33037 1.90485 5.54106 3.72283 3.72307Z",
    fill: "#1C1C1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.e96185f214a36a494ec022cc3cee072c.svg";
export { ForwardRef as ReactComponent };